/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import "popper.js";
import $ from "jquery";
import "bootstrap";
import "../styles/public.scss";

import "../shared/errors";
import "../shared/fonts";
import "../shared/requests";

$(document).ready(() => {
  $(".counter-count").each(function () {
    $(this)
      .prop("Counter", 0)
      .animate(
        {
          Counter: $(this).text(),
        },
        {
          duration: 4000,
          easing: "swing",
          step: function (now) {
            $(this).text(Math.ceil(now));
          },
        },
      );
  });

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 1) {
      $(".navbar").addClass("nav-bg");
    } else {
      $(".navbar").removeClass("nav-bg");
    }
  });
  $(document).on("click", ".scroll-to", function (e) {
    e.preventDefault();
    var element = $($(this).attr("href"));
    $("html, body").animate(
      {
        scrollTop: element.offset().top,
      },
      500,
      "linear",
    );
  });

  $(document).on("click", "[data-link]", function (e) {
    window.open($(this).data("link"));
  });
});
